import { type IstanzaSezioneDati } from '@framework/api-client/api/backoffice/schemas/istanzaSezioneDati.ts';
import {
  type IEngineSection,
  mapToEngineSection,
} from '@framework/engine/schema/sections/IEngineSection.ts';
import { type IRootWidget } from '@framework/engine/schema/widgets/repository/containers/root/IRootWidget.ts';
import { produce } from 'immer';
import { sectionMigrationEngine } from '../../engine/migration/SectionMigrationEngine.ts';

/**
 * Mappa una lista di istanze sezione dati in una lista di engine section,
 * utilizzabili per le altre funzionalità del motore.
 */
export function mapDeclarationSections(
  input: IstanzaSezioneDati[] | null | undefined,
  readonly: boolean,
): IEngineSection[] {
  if (!input) return [];

  const sections = input
    .map(declaration => {
      if (!declaration.idSezioneDati || !declaration.jsonCampi) {
        return null;
      }

      const originalRoot = declaration.jsonCampi as IRootWidget;
      const id = declaration.idSezioneDati;

      const root = sectionMigrationEngine.needMigration(originalRoot)
        ? produce(originalRoot, draft => {
            sectionMigrationEngine.run(draft);
          })
        : originalRoot;

      return mapToEngineSection({
        id,
        elementi: root,
        sectionRootScope: { isReadonly: readonly },
      });
    })
    .filter(Boolean) as IEngineSection[];

  return sections;
}
